import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { LangChangeEvent, TranslateService } from '@ngx-translate/core'

import { Material } from '@models/material'
import { mimeTypes } from '@constants/mimetypes'
import { VideoPreviewComponent } from '../video-preview/video-preview.component'
import { AudioPreviewComponent } from '../audio-preview/audio-preview.component'
import { PdfPreviewComponent } from '../pdf-preview/pdf-preview.component'
import { HtmlPreviewComponent } from '../html-preview/html-preview.component'
import { H5pPreviewComponent } from '../h5p-preview/h5p-preview.component'
import { OfficePreviewComponent } from '../office-preview/office-preview.component'
import { ImagePreviewComponent } from '../image-preview/image-preview.component'
import { FocusRemoverDirective } from '../../directives/focus-remover.directive'

@Component({
  selector: 'app-educational-material-preview',
  templateUrl: './educational-material-preview.component.html',
  styleUrls: ['./educational-material-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    VideoPreviewComponent,
    AudioPreviewComponent,
    PdfPreviewComponent,
    HtmlPreviewComponent,
    H5pPreviewComponent,
    OfficePreviewComponent,
    ImagePreviewComponent,
    FocusRemoverDirective
  ]
})
export class EducationalMaterialPreviewComponent implements OnInit {
  @Input() material: Material
  @Input() isCollection = false
  lang: string = this.translate.getCurrentLang()
  failedH5pPath: string

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang
    })
  }

  public checkMimeType(mimeType: string): string {
    if (mimeTypes.video.includes(mimeType)) {
      return 'video'
    }

    if (mimeTypes.audio.includes(mimeType)) {
      return 'audio'
    }

    if (mimeTypes.pdf.includes(mimeType)) {
      return 'pdf'
    }

    if (mimeTypes.html.includes(mimeType)) {
      return 'html'
    }

    if (mimeTypes.h5p.includes(mimeType) && this.material.filepath !== this.failedH5pPath) {
      return 'h5p'
    }

    if (mimeTypes.office.includes(mimeType)) {
      return 'office'
    }

    if (mimeTypes.image.includes(mimeType)) {
      return 'image'
    }
  }
}
